import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Course } from "../api";
import { TopBar } from "../components/TopBar";

export function CoursesPage() {
  const [courses, setCourses] = useState<Course[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.courses().then(setCourses).catch((e) => setError(e.message));
  }, []);

  return (
    <div className="app-shell">
      <TopBar />
      <main className="catalog">
        <h1>Your courses</h1>
        {error && <p className="form-error">{error}</p>}
        {!courses && !error && <p className="muted">Loading…</p>}
        <div className="course-grid">
          {courses?.map((c) => (
            <Link key={c.slug} to={`/courses/${c.slug}`} className="course-card">
              <h2>{c.title}</h2>
              <p>{c.description}</p>
              <span className="course-card-cta">Open course →</span>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
